export enum PaymentResponseCodes {
    SUCCESS_OPERATION = 50000,
    TRANSACTION_ERROR = 50001,
    DATA_NOT_FOUND = 50002,
    PAYMENT_GATEWAY_ERROR = 50003,
    FAILED_DURING_VALIDATION_PROCESS = 50006,
    VALIDATION_WITH_ERRORS = 50007,
    INTERNAL_SERVER_ERROR = 59999,
}
